type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> & {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  priority?: boolean;
  unoptimized?: boolean;
  placeholder?: "blur" | "empty";
  blurDataURL?: string;
  sizes?: string;
  quality?: number;
};

export default function Image({
  src,
  alt,
  width,
  height,
  fill,
  priority,
  className = "",
  style,
  sizes,
  srcSet,
  ...props
}: ImageProps) {
  const { unoptimized: _u, placeholder: _p, blurDataURL: _b, quality: _q, ...rest } = props;
  const loading = priority ? "eager" : "lazy";
  const fetchPriority = priority ? "high" : undefined;

  if (fill) {
    return (
      <img
        src={src}
        srcSet={srcSet}
        alt={alt}
        className={className}
        sizes={sizes}
        decoding={priority ? "sync" : "async"}
        loading={loading}
        fetchPriority={fetchPriority}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: (style as React.CSSProperties | undefined)?.objectFit ?? "cover",
          ...style,
        }}
        {...rest}
      />
    );
  }
  return (
    <img
      src={src}
      srcSet={srcSet}
      alt={alt}
      width={width}
      height={height}
      className={className}
      sizes={sizes}
      decoding={priority ? "sync" : "async"}
      loading={loading}
      fetchPriority={fetchPriority}
      style={style}
      {...rest}
    />
  );
}
